import { TableRow } from "@material-ui/core";
import React from "react";
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import './pdfStyle.css'

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const data = this.props.data;
        const dayCount = this.props.daysCount;
        const total = this.props.total;
        const allTotal = this.props.allTotal;

        return (
            <div style={{ width: '100%', marginTop: -60 }}>
                <div className="pdf-head">
                    <h3><center><u> Sundry Summary Work Distribution Report</u></center></h3>
                    <div className="row pl-2 pb-4 pt-4">
                        <div className="col"><b>Group: </b> {searchData.group}</div>
                        <div className="col"><b>Operation Entity: </b> {searchData.estate === undefined ? "All Operation Entities" : searchData.estate}</div>
                        <div className="col"><b>Collection Point: </b> {searchData.division === undefined ? "All Collection Points" : searchData.division}</div>
                        <div className="col"><b>Month: </b> {searchData.month}</div>
                    </div>
                    <div>

                        <>
                            <div className="pdf-root">
                                <table className="data-table" id="data-table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center" style={{ width: '185px', fontWeight: "bold" }}>Task Name</TableCell>
                                            {dayCount.map((count, i) => (
                                                <TableCell key={i} align="center" style={{ width: '25px', fontWeight: "bold" }}>{count}</TableCell>
                                            ))}
                                            <TableCell align="center" style={{ width: '38px', fontWeight: "bold" }}>Total</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {data.map((rows, i) => (
                                            <TableRow key={i} >
                                                <TableCell component="th" scope="row" align="left"> {rows.taskName}</TableCell>
                                                {dayCount.map((count) => {
                                                    const result = rows[count]
                                                    return (
                                                        <TableCell component="th" scope="row" align="center"> {result == undefined ? '-' : result}</TableCell>
                                                    );

                                                })}
                                                <TableCell component="th" scope="row" align="center"> {rows.total}</TableCell>
                                            </TableRow>
                                        ))}
                                        <TableRow>
                                            <TableCell component="th" scope="row" align="center" colSpan={1} style={{ fontWeight: "bold" }}> Total</TableCell>
                                            {dayCount.map((column) => {
                                                const value = allTotal.find(x => x.name == column)
                                                return (
                                                    <TableCell style={{ fontWeight: "bold" }} align='center'>{value == undefined ? '-' :
                                                        parseFloat(value.value)}</TableCell>
                                                );
                                            })}
                                            <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold" }}> {parseFloat(total)}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </table>
                            </div>
                        </>
                    </div>
                </div>

            </div>
        );
    }
}